// extracted by mini-css-extract-plugin
export default {"h1":"RestrictedPage_h1__2mF-u","p":"RestrictedPage_p__e9nBL"};